import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { useContext, useEffect, useState } from "react";
import useAPIRequest from "../../../custom_hooks/simple/useAPIRequest";
import ProdukBox from "../components/ProdukBox";
import { dummyListProduk } from "../dummy-data";
import SearchInputText from "../components/SearchInputText";
import { Link } from "react-router-dom";
import UiContext from "../../../store/ui-context";
import { Button } from "primereact/button";
import AppContext from "../../../store/app-context";
import { Dropdown } from "primereact/dropdown";
import TokoBox from "../components/TokoBox";

const isNotMobile = window.innerWidth >= 640;

const ListProdukPage = () => {
  const uiContext = useContext(UiContext);
  const appContext = useContext(AppContext);
  const { requestGet, requestGetOne, requestPost, requestDelete, loading } =
    useAPIRequest();

  const [filterText, setFilterText] = useState("");
  const [listProduk, setListProduk] = useState([]);
  const [listToko, setListToko] = useState([]);

  const [paging, setPaging] = useState({
    page: 1,
    take: 20,
    filter: "",
    total: 0,
  });

  // use effect section

  useEffect(() => {
    if (appContext.selectedKota) {
      fetchListProduk(paging, true);
    }
  }, [appContext.selectedKota]);

  // api call section
  const fetchListProduk = async (_paging, reset) => {
    const _newPaging = _paging || paging;
    if (reset) {
      _newPaging.page = 1;
    }

    const selectedKota = appContext.selectedKota;
    const filterArr = [];
    if (selectedKota) {
      filterArr.push(`kota_id:=:${selectedKota.id}`);
    }

    const _filterText = filterText.toLowerCase();
    if (_filterText && _filterText.length > 0) {
      filterArr.push(`nama:contains:${_filterText}`);
    }

    const _filter = filterArr.join(";");

    return requestGet({
      fullUrl: `/api/masterdata/produk/data/v2`,
      params: {
        page: _newPaging.page,
        take: _newPaging.take,
        filter: _filter,
        order: "nama",
        order_method: "ASC",
      },
      onSuccess: ({ pagination, message, data }) => {
        if (reset) {
          setListProduk(data.data_produks);
          setListToko(data.data_tokos);
        } else {
          setListProduk([...listProduk, ...data.data_produks]);
          setListToko([...listToko, ...data.data_tokos]);
        }
      },
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
    });
  };

  // ui handler section
  const handleSearch = (filterText) => {
    fetchListProduk(paging, true);
  };

  const handleOnClickedLoadMore = () => {
    const _paging = { ...paging, page: paging.page + 1 };
    setPaging(_paging);
    fetchListProduk(_paging, false);
  };

  // custom ui section

  return (
    <div className="col-start-start gap-1 ">
      {/* header section */}
      <div className="col-start-start bg-white w-full shadow-xs px-3 sm:px-5 pt-2 pb-6">
        <div className="row-start-center gap-2 py-4">
          <Link className="px-1" to={-1}>
            <i className="pi pi-arrow-left text-slate-600 text-[0.8rem]" />
          </Link>
          <span className="text-slate-700 text-xl leading-none">Cari Menu</span>
        </div>

        {/* location */}
        <div className="col-center-center w-full pb-2">
          <div className="row-between-center w-full bg-stone-100 py-1 pl-2 pr-1 rounded">
            <span className="text-slate-500 min-w-[9rem]">
              Pilih Lokasi Anda
            </span>

            <Dropdown
              className="border-slate-300 w-full"
              value={appContext.selectedKota}
              onChange={(e) => appContext.setSelectedKota(e.value)}
              options={appContext.listKota}
              optionLabel="nama"
              placeholder="Pilih Kota"
              checkmark={true}
              highlightOnSelect={false}
              pt={{
                input: { className: "text-sm text-slate-500 font-semibold" },
              }}
            />
          </div>
        </div>

        {/* search  */}
        <SearchInputText
          loading={loading}
          value={filterText}
          placeholder="Find Your Favourite Food"
          onChange={(_text) => setFilterText(_text)}
          onSearch={(text) => handleSearch(text)}
        />
      </div>

      {/* list section  */}
      {listToko.length > 0 && (
        <div className="flex flex-col sm:flex-row sm:flex-wrap justify-start items-start w-full shadow-xs py-2 gap-2">
          {filterText &&
            listToko.map((toko) => {
              return <TokoBox toko={toko} />;
            })}
        </div>
      )}
      <div className="flex flex-col sm:flex-row sm:flex-wrap justify-start items-start bg-white w-full shadow-xs px-3 sm:px-5 py-4 gap-4">
        {listProduk.map((produk) => {
          return (
            <ProdukBox
              key={`list-produk-${produk.id}`}
              size={isNotMobile ? "medium" : "large"}
              {...produk}
            />
          );
        })}
      </div>

      <div className="row-center-center py-2 w-full">
        <Button
          className="opacity-80"
          icon="pi pi-sort-down-fill"
          label="Load more"
          loading={loading}
          // outlined
          rounded
          onClick={() => {
            handleOnClickedLoadMore();
          }}
        />
      </div>
    </div>
  );
};

export default ListProdukPage;
